import React from 'react'
import List from './Components/List'
import Create from './Components/Create'
import Form from './Components/Form'

export default function General() {
    return (
        <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-12 col-xl-12 col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Dashboard'; }}>
                                Back
                            </button>
                            <p className='text-right mb-0'><small class="fw-bold py-3">Dashboard<span class="text-muted fw-light"> / General</span> </small></p>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className='card-title mb-0'>My Brand Details</h5>
                                {/* <Create BTNLabel="Add New Package" Header="Create Package" Subheader="Create a new package to improve customer engagements." PopupID="Section" /> */}
                            </div>
                            <div className="card-datatable table-responsive">
                                {/* <List /> */}
                                <div className='container '>
                                    <Form Page='General' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
